export default __webpack_public_path__ + "images/ab56293620186d437a93c2aba7c8e01c-cheer_small.webp";